import { ReactNode } from 'react'
import { Accordion, Button, ScrollArea, Text } from '@mantine/core'
import clsx from 'clsx'

import classes from './menu.module.css'

interface IList {
  id: string
  name: string
  url?: string
}

interface IProps {
  activeId: string
  icon?: ReactNode
  mainIcon?: ReactNode
  name: string
  label: string
  subtitle?: string
  height?: number | string
  list: IList[]
  isDisabled: boolean
  onClick: (id: string, url: string | null, name: string) => void
}

export default function UserAccordionItem({
  activeId,
  name,
  label,
  height,
  list,
  isDisabled,
  onClick,
  mainIcon,
  icon,
  subtitle,
}: IProps) {
  // const isActive = useCallback((id: string) => activeId === id, [activeId])
  if (list.length > 1) {
    return (
      <Accordion.Item value={name}>
        <Accordion.Control
          className={
            'border-solid border-[1px] border-[#C5C7D0] bg-white rounded-[6px] px-3'
          }
          classNames={{ label: 'flex items-center gap-2 py-2', chevron: 'w-[20px]' }}
          disabled={isDisabled}
        >
          {mainIcon}
          <Text className={'font-normal text-[16px]'}>{label}</Text>
        </Accordion.Control>
        <Accordion.Panel
          className={
            'p-3 pr-0 pb-0 border-solid border-t-0 border-[1px] border-[#C5C7D0] rounded-b-[6px]'
          }
        >
          <Text className={'mb-2 text-gray-600 text-[14px]'}>{subtitle}</Text>
          <ScrollArea
            classNames={{ viewport: 'pr-4 overscroll-none' }}
            h={height}
            offsetScrollbars
            scrollbarSize={8}
            type={'always'}
          >
            {list.map((item) => (
              <Button
                className={clsx(
                  'mb-3 w-full rounded-[6px] border-1',
                  activeId === item.id ? classes.itemButtonActive : classes.itemButton,
                )}
                classNames={{
                  root: 'h-[auto] py-2',
                  label: 'w-full flex items-center gap-2 ',
                }}
                disabled={isDisabled}
                key={item.id}
                onClick={() => onClick(item.id, item?.url || null, item.name)}
                radius={0}
              >
                {icon}
                <Text className={'text-[16px]'}>{item.name}</Text>
                {/* {item?.url && <Text className={'text-sm opacity-80'}>{item.url}</Text>} */}
                {/* {isActive(item.id) && (
                <Pill
                  classNames={{
                    root: clsx('mt-0.5', classes.menuButtonActiveText),
                    label: 'text-xs uppercase',
                  }}
                >
                  {t('common.current')}
                </Pill>
              )} */}
              </Button>
            ))}
          </ScrollArea>
        </Accordion.Panel>
      </Accordion.Item>
    )
  }

  return null
}
